import React from 'react';
import { getDeviceStatusText } from '../utils';

const LastEventInfo = ({ device }) => {
  const lastEventInfo = React.useMemo(() => {
    return getDeviceStatusText(device?.last_event?.at);
  }, [device?.last_event?.at]);

  return <div>{lastEventInfo}</div>;
};

export default LastEventInfo;
